import { ChangeDetectionStrategy, Component, HostBinding, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

@Component({
    selector: 'fi-checklist2-template-description',
    template: `
        <mat-card class="fi-rounded-card">
            <mat-card-content>
                <mat-expansion-panel [hideToggle]="true" #expansionPanel>
                    <mat-expansion-panel-header>
                        <span>{{ 'checklist.template_description_header' | fiAppText }}</span>
                        <mat-icon class="far fa-chevron-down" />
                    </mat-expansion-panel-header>
                    <p class="template-description">{{ 'checklist.template_description_main' | fiAppText }}</p>
                    <p class="template-description" [innerHTML]="'checklist.template_description_note' | fiAppText"></p>
                    <p
                        class="template-description"
                        [innerHTML]="'checklist.template_description_example' | fiAppText"
                    ></p>
                </mat-expansion-panel>
            </mat-card-content>
        </mat-card>
    `,
    styleUrl: './fi-checklist2-template-description.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-checklist2-template-description' },
    standalone: false,
})
export class FiChecklist2TemplateDescriptionComponent {
    @ViewChild('expansionPanel') expansionPanel: MatExpansionPanel;
    @HostBinding('class.content-expanded') get isPanelExpanded(): boolean {
        return this.expansionPanel?.expanded;
    }
}
